import { createSlice } from "@reduxjs/toolkit";

export const InitializedProjectWorkflowsSlice = createSlice({
    name : 'initialized_project_workflows',
    initialState : {
        value : []
    },
    reducers : {
        updateInitializedProjectWorkflows : (state, action) => {
            state.value = action.payload
        }
    }
});

export const { updateInitializedProjectWorkflows } = InitializedProjectWorkflowsSlice.actions

export default InitializedProjectWorkflowsSlice.reducer